import { createContext, useContext } from "react";

/**
 * The app shell's scrollport, handed to the page rendered inside it.
 *
 * Layout's root is exactly one viewport tall and clips (`height: dvh(100)`,
 * `overflow: "hidden"`), so the DOCUMENT never scrolls: `window.scrollY` is 0
 * forever and no `scroll` event ever reaches `window`, because element scroll
 * events do not bubble. The element that actually scrolls is Layout's inner
 * `Box` (`overflowY: "auto"`). Any in-shell page that wants to read the scroll
 * offset, listen for scrolling, or scroll the user somewhere has to talk to
 * that element instead of to `window` (P2-59).
 *
 * The value is `null` when there is no shell above the page — auth routes take
 * Layout's bare early return, and unit tests often mount a page on its own. A
 * consumer should fall back to `window` in that case, which is correct there:
 * with no 100dvh clipping ancestor, the document is the scrollport again.
 */
const ScrollContainerContext = createContext(null);

export const ScrollContainerProvider = ScrollContainerContext.Provider;

/** The shell's scrolling element, or `null` when rendered outside the shell. */
export const useScrollContainer = () => useContext(ScrollContainerContext);

export default ScrollContainerContext;
